// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"b0f02136","36":"345ca6f3","142":"e849a8ea","221":"9e42802c","251":"2104e920","268":"6623461f","453":"a3db9364","594":"c83a5f19","604":"51b74839","684":"c2fae00e","743":"f6443243","821":"cd980567","912":"39c4c69c"}[chunkId] + ".chunk.js";
};